<template>
    <div>
        <page-header :title="title" :items="items" />

        <div class="date-picker-wrapper">
            <date-picker
                v-model="dateRange"
                range
                placeholder="Select date"
                :disabled-date="disableFutureDates"
            />
        </div>

        <div v-if="isLoading" class="dashboard-loader">
            <div class="dashboard-spinner">
                <div class="dot1" />
                <div class="dot2" />
            </div>
        </div>
        <div v-else class="dashboard">
            <div class="top-cards">
                <stat-card title="Total HCPs" :value="data.doctorsCount" />
                <stat-card
                    title="Returned Users - Active Users"
                    :value="data.activeUsersCount"
                />
                <stat-card
                    title="Total Referrals"
                    :value="data.setupTrainingCount"
                />
                <stat-card title="Average Rating" :value="data.averageRating" />
            </div>

            <div class="distribution-cards">
                <stat-list
                    title="HCP Distribution"
                    :items="data.userTypesCount"
                    :total="data.activeUsersCount"
                />
                <stat-list
                    title="HCP Specialty"
                    :items="data.specialtiesCount"
                    :total="data.activeUsersCount"
                />
                <stat-list
                    title="HCP Devices"
                    :items="data.devicesCount"
                    :total="data.totalDevices"
                />
            </div>

            <div class="chart-section">
                <stat-chart
                    title="Referrals of products (PSP) to patients"
                    :data="data.setupTrainingData"
                    :total="data.setupTrainingCount"
                />
                <stat-chart
                    title="Views by product"
                    :data="data.productViewsData"
                    :total="data.productViewsCount"
                />
            </div>

            <div class="tables">
                <stat-table
                    title="Top Referring to Files of products"
                    :headers="['name', 'product', 'referrals']"
                    :data="data.productInfoFilesData"
                />
                <stat-table
                    title="Medical info - Top views"
                    :headers="['name', 'category', 'referrals']"
                    :data="data.medicalInfoViewsData"
                />
                <stat-table
                    title="Top Referring of products HCPs"
                    :headers="['name', 'speciality', 'referrals']"
                    :data="data.userSetupTrainingData"
                />
                <stat-table
                    title="Product views - Top HCPs"
                    :headers="['name', 'speciality', 'referrals']"
                    :data="data.userProductViewsData"
                />
            </div>

            <div class="bottom-cards">
                <stat-chart
                    title="Medical info"
                    :data="data.medicalInfoData"
                    :total="data.medicalInfoEventsCount"
                />
                <pending-approval-doctors :data="data.pendingApprovalDoctors" />
            </div>

            <notifications-data :data="data.notificationsData" />
        </div>
    </div>
</template>

<script>
import config from '@config';
import { mapActions } from 'vuex';

import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';

import StatCard from '@components/dashboard/StatCard.vue';
import StatChart from '@/src/components/dashboard/StatChart.vue';
import StatList from '@/src/components/dashboard/StatList.vue';
import StatTable from '@/src/components/dashboard/StatTable.vue';
import NotificationsData from '@/src/components/dashboard/NotificationsData.vue';
import PendingApprovalDoctors from '@/src/components/dashboard/PendingApprovalDoctors.vue';

export default {
    page: {
        title: 'Dashboard',
        meta: [{ name: 'description', content: config.description }]
    },

    components: {
        StatCard,
        StatChart,
        StatList,
        StatTable,
        DatePicker,
        NotificationsData,
        PendingApprovalDoctors
    },

    data() {
        return {
            title: 'Dashboard',
            items: [
                { text: 'NovoCare', to: '/' },
                { text: 'Dashboard', active: true }
            ],
            dateRange: this.getLastMonthRange(),
            data: {},
            isLoading: false
        };
    },

    watch: {
        dateRange: {
            async handler() {
                const [startDate, endDate] = this.dateRange;
                const adjustedEndDate = new Date(endDate);

                adjustedEndDate.setHours(23, 59, 59, 999);

                this.isLoading = true;

                try {
                    this.data = await this.index([startDate, adjustedEndDate]);
                } finally {
                    this.isLoading = false;
                }
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions({
            index: 'dashboard/index'
        }),

        getLastMonthRange() {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const end = new Date(now.getFullYear(), now.getMonth(), 0);

            return [start, end];
        },

        disableFutureDates(date) {
            return date > new Date();
        }
    }
};
</script>
